import { Boxes, Map, Move3D } from 'lucide-react'
import type { CanvasMode } from '../lib/canvasProjection'

type VisualModeTabsProps = {
  active: CanvasMode
  onChange: (mode: CanvasMode) => void
}

const MODES = [
  { id: 'plan-2d', label: 'Plan 2D', hint: 'Voir tout le parcours sur un plan', Icon: Map },
  { id: 'layers-3d', label: 'Couches 3D', hint: 'Comparer la référence, le projet et les différences', Icon: Boxes },
  { id: 'pov-3d', label: 'POV par îlots', hint: 'Avancer dans le parcours depuis sa situation actuelle', Icon: Move3D },
] as const

export function VisualModeTabs({ active, onChange }: VisualModeTabsProps) {
  return (
    <nav className="visual-mode-tabs" aria-label="Choisir une vue du parcours">
      {MODES.map(({ id, label, hint, Icon }) => (
        <button
          aria-current={active === id ? 'page' : undefined}
          className={`visual-mode-tab ${active === id ? 'active' : ''}`}
          key={id}
          onClick={() => onChange(id)}
          title={hint}
          type="button"
        >
          <Icon aria-hidden="true" size={18} />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  )
}
